module.exports = function() {
  return new Worker(__webpack_public_path__ + "fefa35e02f95228c6505.worker.js");
};